import * as marketingAdActions from "../actions/marketingAd";

const defaultState = {
    ad: {
        title: "",
        sub_title: "",
        description: "",
        url: "",
        icon: "",
        is_visible: true
    },
    loading: true,
    isShowingSuccess: false,
    errors: {}
}

export default function(state = defaultState, action) {
    switch (action.type) {
        case marketingAdActions.SET_AD:
            return {
                ...state,
                ad: {
                    ...action.ad
                }
            }
        case marketingAdActions.SET_IS_LOADING:
            return {
                ...state,
                loading: action.isLoading
            }
        case marketingAdActions.SET_IS_SHOWING_SUCCESS_MESSAGE:
            return {
                ...state,
                isShowingSuccess: action.isShowingMessage
            }
        case marketingAdActions.SET_ERRORS:
            return {
                ...state,
                errors: action.errors
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/marketingAd.js